import React from "react";
import { Row, Col, Button } from "antd";

const ContentPart = (props) => {
    return (
        <div id="ContentPartPage">
            <Row gutter={[16, 16]}>
                <Col xs={0} md={4} />
                <Col xs={24} md={16}>
                    <div className="ContentPartPageText">
                        <h2 style={{ textAlign: 'center' }}>The Next Frontier: Where Ambition Meets Opportunity</h2>
                        <p style={{ textAlign: 'justify' }}>
                            Welcome to the 7th edition of Flipkart Connect - Flipkart Ads’ annual flagship event.
                            Designed for the leaders shaping India’s digital commerce landscape, this event brings
                            together top brands and agencies to decode the future of e-retail.
                        </p>

                        <p style={{ textAlign: 'justify' }}>
                            This year’s theme, "The Next Frontier," bridges the gap between tomorrow's consumer
                            insights and the technology needed to capture them. Discover how Flipkart’s advanced
                            ad-tech turns your boldest ambition into reality by completely collapsing the distance
                            between a shopper's first spark of inspiration and their final purchase.
                        </p>

                        <p style={{ textAlign: 'justify' }}>
                            Join us for an evening of forward-looking strategies, the celebration of excellence,
                            and meaningful partnerships that will define your brand's next phase of growth.
                        </p>
                        {/* <div className="contentpartbtnbox">
                            <Button href="#signup" className="header-left-rsvpbtn" type="primary" size="large">
                                RSVP NOW
                            </Button>
                        </div> */}

                    </div>

                </Col>
                <Col xs={0} md={4} />
                {/* <Col
                              span={24}
                              style={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}
                            //   className={`fade ${showEventInfo ? "fade-in" : ""}`}
                            >
                              <div className="hero-event-info">
                                <div className="event-line">
                                  <span>Date: 9<sup>th</sup> April</span>
                                  <span className="divider mobdividerclose">|</span>
                                  <span>Time: 3:00 PM – 9:00 PM</span>
                                  <span className="divider mobdividerclose">|</span>
                                  <span>
                                    Venue:{" "}
                                    <a
                                      href="https://maps.app.goo.gl/7nw5DAb7mNTNfS267?g_st=ic"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="venue-link"
                                    >
                                      Pullman, New Delhi, Aerocity
                                    </a>
                                  </span>
                                </div>
                              </div>
                            </Col> */}

            </Row>
        </div>
    );
};

export default ContentPart;
